import { RefObject, useEffect, useState } from 'react';
import ElementViewportObserver from '../../element-viewport-observer/element-viewport-observer';

type UseLazyLoadImageProps = { imageWrapperRef: RefObject<HTMLDivElement | null>; rootMargin?: string };

const useIsImageVisible = (props: UseLazyLoadImageProps): boolean => {
    const { imageWrapperRef, rootMargin = '100px' } = props;

    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const image = imageWrapperRef.current;
        const shouldObserve = image && !isVisible;

        if (!shouldObserve) {
            return;
        }

        const observer = new ElementViewportObserver(setIsVisible, { trigger: 'is-visible', rootMargin });

        observer.observe(image);

        return () => observer.disconnect();
    }, [rootMargin, isVisible]);

    return isVisible;
};

export default useIsImageVisible;
